import {FORGOT_PASSWORD_SUCCESS, FORGOT_PASSWORD_FAILURE} from './action';

const initialState = {
    forgotPasswordSuccess: {},
    forgotPasswordFailure:{}
}

const forgotPasswordReducer = (state=initialState, action) => {
    switch(action.type) {
        case FORGOT_PASSWORD_SUCCESS:
            return  state = {
                ...state,
                forgotPasswordSuccess: action.data
            }
        case FORGOT_PASSWORD_FAILURE:
            return  state = {
                ...state,
                forgotPasswordFailure: action.data
            }
        default: return state
    }
}
export default forgotPasswordReducer;